// src/components/ErrorBoundary.jsx
import React from "react";


export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null, errorInfo: null };

  // Marca que houve erro
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  // Captura o erro e envia para o Asana
  async componentDidCatch(error, errorInfo) {
    
    console.error("ErrorBoundary capturou:", error, errorInfo);
    this.setState({ error, errorInfo });

    // --- Configurações do Asana ---
    const token = process.env.REACT_APP_ASANA_TOKEN;
    const environment = process.env.REACT_APP_ENVIRONMENT || "unknown";
    const backendUrl = process.env.REACT_APP_BACKEND_URL || "unknown";
    const workspaceGid = "4396892435948";
    const projectGid = "25883524292388";
    // -----------------------------
    console.log("ASANA_TOKEN =", token);

    const taskName  = `[WZAP][${environment}] Erro inesperado: ${error.message}`;
    const taskNotes = [
      `**Ambiente:** ${environment}`,
      `**URL:** ${window.location.href}`,
      `**Backend:** ${backendUrl}`,
      `**Mensagem:** ${error.toString()}`,
      `**Stack trace:**`,
      errorInfo.componentStack
    ].join("\n\n");

    try {
      const response = await fetch("https://app.asana.com/api/1.0/tasks", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type":  "application/json"
        },
        body: JSON.stringify({
          data: {
            workspace: workspaceGid,
            name:      taskName,
            notes:     taskNotes,
            assignee:  "1200880145801811", // ID do usuário que receberá a tarefa
            // só inclua projects se tiver um projectGid definido
            ...(projectGid && { projects: [projectGid] })
          }
        })
      });

      if (!response.ok) {
        console.error(
          "Falha ao criar tarefa no Asana:",
          response.status,
          await response.text()
        );
      } else {
        const data = await response.json();
        console.log("Tarefa criada no Asana:", data);
      }
    } catch (err) {
      console.error("Erro ao enviar tarefa para o Asana:", err);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h2>Ops! Algo deu errado.</h2>
          <p>
            Ocorreu um erro inesperado. Nossa equipe já foi notificada e está
            trabalhando para resolver o problema.
          </p>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              marginTop: "1rem",
              textAlign: "left",
              background: "#f5f5f5",
              padding: "1rem",
              borderRadius: "4px"
            }}
          >
            {this.state.error && this.state.error.toString()}
            {"\n"}
            {this.state.errorInfo?.componentStack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
